import React from 'react';
import CasinoContainer from '../../../../components/casino/CasinoContainer';
import CaptchaSettingContent from './CaptchaSettingContent';

export default function CasinoCaptchaSetting() {
  return (
    <CasinoContainer title={'Captcha settings for'}>
      <CaptchaSettingContent />
    </CasinoContainer>
  );
}
